import { createAction } from "redux-actions";
import createAsyncActions from "../../../utilities/createAsyncActions";
import {
  CLEAR_SCORING_DECISION_TEMPLATE,
  GET_SCORING_DECISION_TEMPLATE,
} from "../types";

export const {
  getScoringDecisionTemplate,
  getScoringDecisionTemplatePending,
  getScoringDecisionTemplateFulfilled,
  getScoringDecisionTemplateRejected,
} = createAsyncActions(
  GET_SCORING_DECISION_TEMPLATE,
  "getScoringDecisionTemplate"
);

export const clearScoringDecisionTemplate = createAction(
  CLEAR_SCORING_DECISION_TEMPLATE
);



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/getScoringDecisionTemplateActions.js